var React = require('react');

function Ccpa (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M30.5 24.5H25.5V45.5H55.5V24.5H50.5V19.5C50.5 13.9772 46.0228 9.5 40.5 9.5C34.9772 9.5 30.5 13.9772 30.5 19.5V24.5ZM36.5 24.5H44.5V19.5C44.5 17.2909 42.7091 15.5 40.5 15.5C38.2909 15.5 36.5 17.2909 36.5 19.5V24.5Z","fill":"white","key":0}),React.createElement("path",{"d":"M27.5 0.5V20.5H21.5V49.5H51.5L64.5 62.5V76.5L44.5 79.5V73.5L31.5 65.5H22.5V57.5L13.5 45.5V42.5L8.5 34.5V31.5L2.5 25.5V17.5L0 14.5L2.5 6.5V0.5H27.5Z","fill":"#CED4DA","key":1}),React.createElement("path",{"d":"M30.5 68.5H22.5V71.5H30.5V68.5Z","fill":"#CED4DA","key":2}),React.createElement("path",{"d":"M33.5 70.5H36.5V73.5H33.5V70.5Z","fill":"#CED4DA","key":3}),React.createElement("path",{"d":"M33.5 73.5V76.5H30.5V73.5H33.5Z","fill":"#CED4DA","key":4})]);
}

Ccpa.defaultProps = {"width":"65","height":"80","viewBox":"0 0 65 80","fill":"none"};

module.exports = Ccpa;

Ccpa.default = Ccpa;
